// src/App.tsx
import "./App.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { StatsProvider } from "./context/StatsContext";

/* Layouts */
import AppLayout from "./components/applayout";

/* Pages - Public */
import HomePage from "./components/Home/homepage";
import AboutUsSection from "./components/AboutPage/aboutpage";
import FounderPage from "./components/AboutPage/founder";
import BlogSection from "./components/blogPage/blogpage";
import ContactUsPage from "./components/Contactpage/contactus";
import SignupPage from "./components/JoinNow/SignUp";
import LoginPage from "./components/JoinNow/loginpage";
import Login from "./components/YogaTrainer/login";
import SignUp from "./components/YogaTrainer/Signup";
import ForgotPassword from "./components/ForgotPasswords/forgot";
import ResetPassword from "./components/ForgotPasswords/reset";
import DeleteAccount from "./pages/DeleteAccount";
import PaymentSuccess from "./pages/PaymentSuccess";

/* Services */
import LabTestPage from "./components/Services/LabTestPage/labTest";
import LabTestDetailPage from "./components/Services/LabTestPage/LabTestDetailPage";
import BookingSuccessPage from "./components/Services/LabTestPage/BookingSuccessPage";
import YogaInstructorPage from "./components/Services/YogaInstructor/YogaInstructor";
import AyurvedicDoctorPage from "./components/Services/AyurvedicDoctor/AyurvedicDoctor";
import WellnessAndNaturopathy from "./components/Services/WellnessAndNaturopathy/WellnessAndNaturopathy";
import WellnessAndNaturopathyDetailPage from "./components/Services/WellnessAndNaturopathy/WellnessAndNaturopathyDetailPage";
import WellnessBookPackagePage from "./components/Services/WellnessAndNaturopathy/WellnessBookPackagePage";
import WellnessBookingPreview from "./components/Services/WellnessAndNaturopathy/WellnessBookingPreview";
import MentalWellness from "./components/Services/MentalWellness/MentalWellness";
import WellnessProducts from "./components/Services/WellnessProducts/WellnessProducts";
import WellnessTreatments from "./components/Services/WellnessTreatments/WellnessTreatments";
import WellnessRetreats from "./components/Services/WellnessRetreats/WellnessRetreats";
import AIDietNutrition from "./components/AIDietNutrition/AIDietNutrition";
import SoundTherapy from "./components/Services/SoundTherapy/SoundTherapy";
import SoundTherapyForm from "./components/Services/SoundTherapy/SoundTherapy";
import DmitTest from "./components/Services/DmitTest/DmitTest";
import DmitTestBooking from "./components/Services/DmitTest/DmitTestBooking";
import HumanPsychologyDemoPage from "./components/Services/HumanPsychology/HumanPsychology";
import NutritionalDietPlanDemoPage from "./components/Services/NutritionalDietPlan/NutritionalDietPlan";

/* Profiles & Classes */
import UserProfile from "./components/userprofile/profile";
import UserSettings from "./components/userprofile/profileSettings";
import InstructorProfilePage from "./components/instrutorProfile/InstructorProfile";
import InstructorSettingsAndProfile from "./components/instrutorProfile/instructorProfileSettings";
import InstructorSettingsAndBlog from "./components/instrutorProfile/createBlog";
import Newblog from "./components/instrutorProfile/NewBlog";
import PractitionerProfile from "./pages/PractitionerProfile";
import ClassesDesign from "./components/AllClasses/Classes";
import ClassDetailsPage from "./components/AllClasses/classDetailPage";
import ServicesPage from "./components/ServicesPage/ServicesPage";

import ViewBlog from "./components/Home/viewBlog";
import SoundTherapyDetailsPage from "./components/Services/SoundTherapy/SoundTherapyDetailsPage";

import PrivacyPolicy from "./components/policy/privacypolicy";
import TermsConditions from "./components/policy/terms&conditions";
import CancellationRefund from "./components/policy/cancellation&refund";
import PublicPsycologyProfile from "./components/Services/HumanPsychology/publicPsycologyProfile";
import PsychologyBookSession from "./components/Services/HumanPsychology/bookSession";
import SpecialityListing from "./pages/SpecialityListing";
import PillarCategoryPage from "./pages/PillarCategoryPage";
import BookingStep1 from "./pages/BookingStep1";
import BookingStep2 from "./pages/BookingStep2";
import BookingStep3 from "./pages/BookingStep3";
import AdminReviews from "./admin/AdminReviews";
import AdminDashboard from "./admin/AdminDashboard";

function App() {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <AppLayout />,
      children: [
        { index: true, element: <HomePage /> },
        { path: "admin", element: <AdminDashboard /> },
        { path: "admin/dashboard", element: <AdminDashboard /> },
        { path: "admin/reviews", element: <AdminReviews /> },
        { path: "about", element: <AboutUsSection /> },
        { path: "founder", element: <FounderPage /> },
        { path: "blog", element: <BlogSection /> },
        { path: "blog/:id", element: <ViewBlog /> },
        { path: "contact", element: <ContactUsPage /> },
        { path: "ai-diet-nutrition", element: <AIDietNutrition /> },
        { path: "services", element: <ServicesPage /> },

        { path: "signup", element: <SignupPage /> },
        { path: "login", element: <LoginPage /> },
        { path: "trainer-login", element: <Login /> },
        { path: "trainer-signup", element: <SignUp /> },

        { path: "lab-test", element: <LabTestPage /> },
        { path: "lab-test/:testId", element: <LabTestDetailPage /> },
        { path: "booking-success/:bookingId", element: <BookingSuccessPage /> },
        { path: "yoga-instructor", element: <YogaInstructorPage /> },
        { path: "ayurvedic-doctor", element: <AyurvedicDoctorPage /> },
        { path: "therapeutic-wellness-treatment", element: <WellnessTreatments /> },
        { path: "luxury-wellness-retreats/:packageId", element: <WellnessAndNaturopathyDetailPage /> },
        { path: "luxury-wellness-retreats/:packageId/book", element: <WellnessBookPackagePage /> },
        { path: "luxury-wellness-retreats/book-package", element: <WellnessBookPackagePage /> },
        { path: "luxury-wellness-retreats/booking-preview", element: <WellnessBookingPreview /> },
        { path: "mental-wellness", element: <MentalWellness /> },
        { path: "human-psychology", element: <HumanPsychologyDemoPage /> },
        { path: "nutritional-diet-plan", element: <NutritionalDietPlanDemoPage /> },
        { path: "wellness-products", element: <WellnessProducts /> },
        { path: "luxury-wellness-retreats", element: <WellnessAndNaturopathy /> },
        { path: "wellness-retreats", element: <WellnessRetreats /> },
        { path: "Sound-therapy", element: <SoundTherapy /> },
        { path: "class-details/sound-therapy", element: <SoundTherapyForm /> },
        { path: "Dmit-tests", element: <DmitTest /> },
        { path: "dmit-tests/booking", element: <DmitTestBooking /> },
        { path: "public/psycology-profile/:id", element: <PublicPsycologyProfile /> },
        { path: "psychology/session/:doctorId/:sessionId", element: <PsychologyBookSession /> },

        { path: "profile", element: <UserProfile /> },
        { path: "profile/user-profile-settings", element: <UserSettings /> },
        { path: "instructor-profile", element: <InstructorProfilePage /> },
        { path: "instructor/instructor-profile-settings", element: <InstructorSettingsAndProfile /> },
        { path: "instructor/instructor-profile-blogs", element: <InstructorSettingsAndBlog /> },
        { path: "instructor/instructor-profile-newblogs", element: <Newblog /> },
        { path: "instructor/edit-blog/:id", element: <Newblog /> },
        { path: "public/instructor-profile/:id", element: <PractitionerProfile /> },
        { path: "sound-therapy/details", element: <SoundTherapyDetailsPage /> },
        { path: "classes", element: <ClassesDesign /> },
        { path: "class-details/:userId", element: <ClassDetailsPage /> },
        { path: "forgot-password/:resetType", element: <ForgotPassword /> },
        { path: "reset-password/:resetToken", element: <ResetPassword /> },
        { path: "user/delete-account", element: <DeleteAccount /> },
        { path: "view-blog/:id", element: <ViewBlog /> },
        { path: "speciality/:tag", element: <SpecialityListing /> },
        { path: "pillar/:pillarSlug", element: <PillarCategoryPage /> },
        { path: "booking/:slug/step1", element: <BookingStep1 /> },
        { path: "booking/:slug/step2", element: <BookingStep2 /> },
        { path: "booking/:slug/step3", element: <BookingStep3 /> },
        { path: "payment-success", element: <PaymentSuccess /> },
        { path: "policy/privacy-policy", element: <PrivacyPolicy /> },
        { path: "policy/terms-conditions", element: <TermsConditions /> },
        { path: "policy/cancellation-refund", element: <CancellationRefund /> },
        { path: "*", element: <h1 className="p-10 text-center">No Page Found</h1> },
      ],
    },
  ]);

  return (
    <StatsProvider>
      <RouterProvider router={router} />
    </StatsProvider>
  );
}

export default App;
